module.exports = __webpack_public_path__ + "img/04.c12d226e.jpg";